import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["agenciesContainer", "agenciesField"]

  connect() {
    console.log("AgenciesManager controller connected")
    const fieldValue = this.agenciesFieldTarget.value
    console.log("Raw field value:", fieldValue)

    try {
      if (fieldValue && fieldValue.trim() !== '') {
        const parsedData = JSON.parse(fieldValue)
        if (Array.isArray(parsedData)) {
          this.agencies = { agencies: parsedData }
        } else if (parsedData.agencies && Array.isArray(parsedData.agencies)) {
          this.agencies = parsedData
        } else {
          this.agencies = { agencies: [] }
        }
      } else {
        this.agencies = { agencies: [] }
      }
    } catch (error) {
      console.error("Error parsing JSON:", error)
      this.agencies = { agencies: [] }
    }

    console.log("Final agencies object:", this.agencies)
    this.renderAgencies()
  }

  addAgency() {
    console.log("addAgency called")
    const newAgency = {
      company_name: "",
      siret: "",
      address: "",
      pro_card: {
        numero: "",
        issued_date: "",
        issuer: ""
      },
      representatives: []
    }

    this.agencies.agencies.push(newAgency)
    this.updateField()
    this.renderAgencies()
  }

  removeAgency(event) {
    event.preventDefault()
    event.stopPropagation()
    const agencyIndex = parseInt(event.currentTarget.dataset.agencyIndex)
    this.agencies.agencies.splice(agencyIndex, 1)
    this.updateField()
    this.renderAgencies()
  }

  toggleAgency(event) {
    event.preventDefault()
    const agencyIndex = event.currentTarget.dataset.agencyIndex
    const collapseElement = document.querySelector(`#collapse-agency-${agencyIndex}`)

    if (collapseElement) {
      const bsCollapse = new bootstrap.Collapse(collapseElement, { toggle: true })
    }
  }

  addRepresentative(event) {
    event.preventDefault()
    event.stopPropagation()
    const agencyIndex = parseInt(event.currentTarget.dataset.agencyIndex)
    const newRepresentative = {
      title: "",
      first_name: "",
      last_name: ""
    }

    this.agencies.agencies[agencyIndex].representatives.push(newRepresentative)
    this.updateField()

    // Store the currently open collapse before re-rendering
    const collapseElement = document.querySelector(`#collapse-agency-${agencyIndex}`)
    const isOpen = collapseElement && (
      collapseElement.classList.contains('show') ||
      collapseElement.style.display !== 'none'
    )

    this.renderAgencies()

    // Re-open the collapse after rendering if it was open
    if (isOpen) {
      setTimeout(() => {
        const newCollapse = document.querySelector(`#collapse-agency-${agencyIndex}`)
        if (newCollapse) {
          const bsCollapse = new bootstrap.Collapse(newCollapse, { show: true })
        }
      }, 50)
    }
  }

  removeRepresentative(event) {
    event.preventDefault()
    event.stopPropagation()
    const agencyIndex = parseInt(event.currentTarget.dataset.agencyIndex)
    const representativeIndex = parseInt(event.currentTarget.dataset.representativeIndex)

    this.agencies.agencies[agencyIndex].representatives.splice(representativeIndex, 1)
    this.updateField()

    // Store the currently open collapse before re-rendering
    const collapseElement = document.querySelector(`#collapse-agency-${agencyIndex}`)
    const isOpen = collapseElement && (
      collapseElement.classList.contains('show') ||
      collapseElement.style.display !== 'none'
    )

    this.renderAgencies()

    // Re-open the collapse after rendering if it was open
    if (isOpen) {
      setTimeout(() => {
        const newCollapse = document.querySelector(`#collapse-agency-${agencyIndex}`)
        if (newCollapse) {
          const bsCollapse = new bootstrap.Collapse(newCollapse, { show: true })
        }
      }, 50)
    }
  }

  updateAgencyField(event) {
    const agencyIndex = parseInt(event.currentTarget.dataset.agencyIndex)
    const fieldName = event.currentTarget.dataset.fieldName
    const value = event.currentTarget.value

    if (fieldName.startsWith('pro_card.')) {
      const cpField = fieldName.replace('pro_card.', '')
      if (!this.agencies.agencies[agencyIndex].pro_card) {
        this.agencies.agencies[agencyIndex].pro_card = {}
      }
      this.agencies.agencies[agencyIndex].pro_card[cpField] = value
    } else {
      this.agencies.agencies[agencyIndex][fieldName] = value
    }

    this.updateField()

    // Update the header if it's the company_name or siret
    if (fieldName === 'company_name' || fieldName === 'siret') {
      this.updateAgencyHeader(agencyIndex)
    }
  }

  updateRepresentativeField(event) {
    const agencyIndex = parseInt(event.currentTarget.dataset.agencyIndex)
    const representativeIndex = parseInt(event.currentTarget.dataset.representativeIndex)
    const fieldName = event.currentTarget.dataset.fieldName
    const value = event.currentTarget.value

    this.agencies.agencies[agencyIndex].representatives[representativeIndex][fieldName] = value
    this.updateField()
  }

  updateAgencyHeader(agencyIndex) {
    const agency = this.agencies.agencies[agencyIndex]
    const headerButton = document.querySelector(`[data-agency-index="${agencyIndex}"][data-action*="toggleAgency"]`)
    if (headerButton) {
      const titleSpan = headerButton.querySelector('.agency-title')
      if (titleSpan) {
        titleSpan.textContent = agency.company_name || `Agence ${agencyIndex + 1}`
      }
    }
  }

  updateField() {
    this.agenciesFieldTarget.value = JSON.stringify(this.agencies)
    console.log("Field updated with:", this.agenciesFieldTarget.value)
  }

  renderAgencies() {
    // Store currently open collapses
    const openCollapses = Array.from(document.querySelectorAll('[id^="collapse-agency-"]')).filter(el => {
      return el.classList.contains('show') ||
             el.style.display !== 'none' ||
             (el.id === 'collapse-agency-0' && this.agencies.agencies.length > 0)
    }).map(el => el.id)

    this.agenciesContainerTarget.innerHTML = this.generateAgenciesHTML()

    // Re-open previously open collapses or open first one by default
    setTimeout(() => {
      if (openCollapses.length > 0) {
        openCollapses.forEach(collapseId => {
          const collapse = document.querySelector(`#${collapseId}`)
          if (collapse) {
            const bsCollapse = new bootstrap.Collapse(collapse, { show: true })
          }
        })
      } else if (this.agencies.agencies.length > 0) {
        // Open first collapse by default if no collapses were previously open
        const firstCollapse = document.querySelector('#collapse-agency-0')
        if (firstCollapse) {
          const bsCollapse = new bootstrap.Collapse(firstCollapse, { show: true })
        }
      }
    }, 50)
  }

  generateAgenciesHTML() {
    if (this.agencies.agencies.length === 0) {
      return `
        <div class="text-center p-4">
          <p class="text-muted mb-3">Aucune agence ajoutée</p>
          <button type="button" class="btn btn-primary" data-action="click->agencies-manager#addAgency">
            <i class="fas fa-plus me-2"></i>Ajouter une agence
          </button>
        </div>
      `
    }

    let html = ''

    html += `
      <div class="mt-2 mb-2 text-center">
        <button type="button" class="btn btn-outline-primary" data-action="click->agencies-manager#addAgency">
          <i class="fas fa-plus me-2"></i>Ajouter une agence
        </button>
      </div>
    `

    this.agencies.agencies.forEach((agency, agencyIndex) => {
      html += this.generateAgencyHTML(agency, agencyIndex)
    })



    return html
  }

  generateAgencyHTML(agency, agencyIndex) {
    const collapseId = `collapse-agency-${agencyIndex}`
    const isFirstAgency = agencyIndex === 0

    return `
      <div class="card mb-3">
        <!-- Header -->
        <div class="card-header bg-light">
          <div class="d-flex align-items-center justify-content-between">
            <button type="button" class="btn btn-link text-decoration-none p-0 flex-grow-1 text-start"
                    data-action="click->agencies-manager#toggleAgency"
                    data-agency-index="${agencyIndex}"
                    data-bs-toggle="collapse"
                    data-bs-target="#${collapseId}"
                    aria-expanded="${isFirstAgency ? 'true' : 'false'}"
                    aria-controls="${collapseId}">
              <div class="d-flex align-items-center">
                <i class="fas fa-chevron-right me-2" id="icon-${agencyIndex}"></i>
                <i class="fas fa-building me-2"></i>
                <span class="agency-title fw-bold">${agency.company_name || `Agence ${agencyIndex + 1}`}</span>
                ${agency.siret ? `<small class="text-muted ms-2">(${agency.siret})</small>` : ''}
              </div>
            </button>
            <button type="button" class="btn btn-sm"
                    data-action="click->agencies-manager#removeAgency"
                    data-agency-index="${agencyIndex}">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>

        <!-- Collapsible Content -->
        <div id="${collapseId}" class="collapse ${isFirstAgency ? 'show' : ''}">
          <div class="card-body">
            ${this.generateAgencyFormHTML(agency, agencyIndex)}
            ${this.generateRepresentativesHTML(agency.representatives, agencyIndex)}
          </div>
        </div>
      </div>
    `
  }

  generateAgencyFormHTML(agency, agencyIndex) {
    return `
      <div class="form-group string required mb-3">
        <label class="string required" for="agency_${agencyIndex}_company_name">
          Raison sociale <abbr title="obligatoire">*</abbr>
        </label>
        <input type="text" class="form-control string required"
               id="agency_${agencyIndex}_company_name"
               value="${agency.company_name || ''}"
               placeholder="Nom de l'agence"
               required="required"
               aria-required="true"
               data-action="input->agencies-manager#updateAgencyField"
               data-agency-index="${agencyIndex}"
               data-field-name="company_name">
      </div>

      <div class="form-group string required mb-3">
        <label class="string required" for="agency_${agencyIndex}_siret">
          SIRET <abbr title="obligatoire">*</abbr>
        </label>
        <input type="text" class="form-control string required"
               id="agency_${agencyIndex}_siret"
               value="${agency.siret || ''}"
               placeholder="Numéro à 14 chiffres"
               required="required"
               aria-required="true"
               data-action="input->agencies-manager#updateAgencyField"
               data-agency-index="${agencyIndex}"
               data-field-name="siret">
      </div>

      <div class="form-group text required mb-3">
        <label class="text required" for="agency_${agencyIndex}_address">
          Adresse <abbr title="obligatoire">*</abbr>
        </label>
        <textarea class="form-control text required"
                  id="agency_${agencyIndex}_address"
                  rows="3"
                  placeholder="Adresse complète de l'agence"
                  required="required"
                  aria-required="true"
                  data-action="input->agencies-manager#updateAgencyField"
                  data-agency-index="${agencyIndex}"
                  data-field-name="address">${agency.address || ''}</textarea>
      </div>

      <fieldset class="border-top pt-3 mb-3">
        <legend class="h6 mb-3">
          <i class="fas fa-id-card me-2"></i>
          Carte professionnelle
        </legend>

        <div class="row justify-content-center g-2">
          <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
            <div class="form-group string required mb-3">
              <label class="string required" for="agency_${agencyIndex}_cp_numero">Numéro</label>
              <input type="text" class="form-control string required"
                     id="agency_${agencyIndex}_cp_numero"
                     value="${agency.pro_card?.numero || ''}"
                     placeholder="Numéro de carte"
                     required="required"
                     aria-required="true"
                     data-action="input->agencies-manager#updateAgencyField"
                     data-agency-index="${agencyIndex}"
                     data-field-name="pro_card.numero">
            </div>
          </div>
          <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
            <div class="form-group date required mb-3">
              <label class="date required" for="agency_${agencyIndex}_cp_date">Date de délivrance</label>
              <input type="date" class="form-control date required"
                     id="agency_${agencyIndex}_cp_date"
                     value="${agency.pro_card?.issued_date || ''}"
                     data-action="input->agencies-manager#updateAgencyField"
                     data-agency-index="${agencyIndex}"
                     data-field-name="pro_card.issued_date">
            </div>
          </div>
          <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
            <div class="form-group string required mb-3">
              <label class="string required" for="agency_${agencyIndex}_cp_delivree">Délivrée par</label>
              <input type="text" class="form-control string required"
                     id="agency_${agencyIndex}_cp_delivree"
                     value="${agency.pro_card?.issuer || ''}"
                     placeholder="Préfecture de..."
                     required="required"
                    aria-required="true"
                     data-action="input->agencies-manager#updateAgencyField"
                     data-agency-index="${agencyIndex}"
                     data-field-name="pro_card.issuer">
            </div>
          </div>
        </div>
      </fieldset>
    `
  }

  generateRepresentativesHTML(representatives, agencyIndex) {
    let html = `
      <fieldset class="border-top pt-3">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <legend class="h6 mb-0">
            <i class="fas fa-users me-2"></i>
            Représentants (${representatives.length})
          </legend>
          <button type="button" class="btn btn-outline-primary btn-sm"
                  data-action="click->agencies-manager#addRepresentative"
                  data-agency-index="${agencyIndex}">
            <i class="fas fa-plus me-1"></i>Ajouter un représentant
          </button>
        </div>
    `

    if (representatives.length === 0) {
      html += '<p class="text-muted text-center py-3 mb-0"><em>Aucun représentant ajouté</em></p>'
    } else {
      representatives.forEach((representative, representativeIndex) => {
        html += this.generateRepresentativeHTML(representative, agencyIndex, representativeIndex)
      })
    }

    html += '</fieldset>'
    return html
  }

  generateRepresentativeHTML(representative, agencyIndex, representativeIndex) {
    return `
      <div class="card mb-3">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="card-title mb-0">
              <i class="fas fa-user me-2"></i>
              Représentant ${representativeIndex + 1}
            </h6>
            <button type="button" class="btn btn-sm"
                    data-action="click->agencies-manager#removeRepresentative"
                    data-agency-index="${agencyIndex}"
                    data-representative-index="${representativeIndex}">
              <i class="fas fa-trash"></i>
            </button>
          </div>

          <div class="row justify-content-center g-2">
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <div class="form-group string required mb-3">
                <label class="string required" for="rep_${agencyIndex}_${representativeIndex}_first_name">
                  Prénom <abbr title="obligatoire">*</abbr>
                </label>
                <input type="text" class="form-control string required"
                       id="rep_${agencyIndex}_${representativeIndex}_first_name"
                       value="${representative.first_name || ''}"
                       placeholder="Prénom"
                       required="required"
                       aria-required="true"
                       data-action="input->agencies-manager#updateRepresentativeField"
                       data-agency-index="${agencyIndex}"
                       data-representative-index="${representativeIndex}"
                       data-field-name="first_name">
              </div>
            </div>
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <div class="form-group string required mb-3">
                <label class="string required" for="rep_${agencyIndex}_${representativeIndex}_last_name">
                  Nom <abbr title="obligatoire">*</abbr>
                </label>
                <input type="text" class="form-control string required"
                       id="rep_${agencyIndex}_${representativeIndex}_last_name"
                       value="${representative.last_name || ''}"
                       placeholder="Nom"
                       required="required"
                       aria-required="true"
                       data-action="input->agencies-manager#updateRepresentativeField"
                       data-agency-index="${agencyIndex}"
                       data-representative-index="${representativeIndex}"
                       data-field-name="last_name">
              </div>
            </div>
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <div class="form-group string required mb-3">
                <label class="string required" for="rep_${agencyIndex}_${representativeIndex}_title">
                  Fonction <abbr title="obligatoire">*</abbr>
                </label>
                <input type="text" class="form-control string required"
                       id="rep_${agencyIndex}_${representativeIndex}_title"
                       value="${representative.title || ''}"
                       placeholder="Gérant, PDG, etc."
                       required="required"
                       aria-required="true"
                       data-action="input->agencies-manager#updateRepresentativeField"
                       data-agency-index="${agencyIndex}"
                       data-representative-index="${representativeIndex}"
                       data-field-name="title">
              </div>
            </div>
          </div>
        </div>
      </div>
    `
  }
}
